import SeriesProps from './SeriesProps'
import Vue from 'vue'

let KendoSparklineSeriesItem = {
    name: 'kendo-sparkline-series-item',
    render () {
        return Vue.prototype._e
    },
    mixins: [SeriesProps]
}

export default KendoSparklineSeriesItem


// WEBPACK FOOTER //
// ./packages/kendo-charts-vue-wrapper/src/KendoSparkline/KendoSparklineSeriesItem.js